/** 接口调用相关 state */

const state = {
  // make talking-photo's request params
  talkingPhotoParams: {
    // uploaded photo url 
    photoUrl: '',
    // generated audio url && info list
    audioList: [],
    // watermark or not (default: 1; 1: with watermark; 0: without watermark)
    watermark: 1,
    // enhancer or not
    isEnhancer: false,
    // case id
    caseId: null
  },
  // talking-photo's photo info
  talkingPhotoInfo: {
    width: 0,
    height: 0,
    boxes: [],
    // photo face gender (0: male; 1: female)
    gender: 0,
    /**
     * speaker info
     * default male: { speakerName: 'Albie Wood'; speaker: 'mercury_davis' }
     * default female: { speakerName: 'Lottie Miller'; speaker: 'mercury_nancy' }
     */
    speakerInfo: {
      speaker: 'mercury_davis',
      speakerSpeed: 1,
      speakerPitch: 0
    }
  },
  // talking-photo's common data
  talkingPhotoCommon: {
    // talking photo template
    talkingFacePhoto: {},
    // message dialog options
    messageDialog: {
      visible: false,
      title: '',
      content: '',
      button: ''
    },
    // global loading
    isLoadingVisible: false
  },
  // 显示类型 0 默认录音页面 1 详情页面
  showType: 0
}

const getters = {
  // make talking photo disabled state
  isMakeTalkingPhotoDisabled: () => {
    return (
      !state.talkingPhotoParams.photoUrl ||
      !state.talkingPhotoParams.audioList.filter(item => item.audioUrl && item.box.length).length
    )
  },
  // is audio list visible
  isAudioOperationVisible: () => {
    return state.talkingPhotoParams.photoUrl
  },
  // is photo own multiple face
  isPhotoOwnMultipleFace: () => {
    return state.talkingPhotoInfo.boxes.length > 1
  }
}

const mutations = {
  /********** talkingPhotoParams **********/
  setPhotoUrlState(state, value) {
    state.talkingPhotoParams.photoUrl = value
  },
  setAudioListState(state, value) {
    state.talkingPhotoParams.audioList = value
    console.log('setAudioListState', value)
  },
  setWatermarkState(state, value) {
    state.talkingPhotoParams.watermark = value
  },
  setEnhancerState(state, value) {
    state.talkingPhotoParams.isEnhancer = value
  },
  setCaseIdState(state, value) {
    state.talkingPhotoParams.caseId = value
  },
  /********** talkingPhotoInfo **********/
  setPhotoWidthState(state, value) {
    state.talkingPhotoInfo.width = value
  },
  setPhotoHeightState(state, value) {
    state.talkingPhotoInfo.height = value
  },
  setPhotoBoxesState(state, value) {
    state.talkingPhotoInfo.boxes = value
  },
  setPhotoGenderState(state, value) {
    state.talkingPhotoInfo.gender = value
  },
  setSpeakerState(state, value) {
    state.talkingPhotoInfo.speakerInfo.speaker = value
  },
  setSpeakerSpeedState(state, value) {
    state.talkingPhotoInfo.speakerInfo.speakerSpeed = value
  },
  setSpeakerPitchState(state, value) {
    state.talkingPhotoInfo.speakerInfo.speakerPitch = value
  },
  /********** talkingPhotoCommon **********/
  setPhotoFaceTempState(state, value) {
    state.talkingPhotoCommon.talkingFacePhoto = value
  },
  setMessageDialogState(state, value) {
    state.talkingPhotoCommon.messageDialog = {
      visible: value.visible,
      title: value.title,
      message: value.message,
      button: value.button
    }
  },
  setLoadingVisibleState(state, value) {
    state.talkingPhotoCommon.isLoadingVisible = value
  },
  /************* showType ******************/
  setPhotoShowType(state, value) {
    state.showType = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}